const MESSAGE_KEYS = ['message', 'msg', 'detail', 'error', 'description'];

const isTechnicalErrorMessage = (message) => {
  if (!message || typeof message !== 'string') {
    return true;
  }

  return (
    message.includes('is not a function') ||
    message.includes('is not an object') ||
    message === 'Network Error' ||
    /^Request failed with status code \d+$/.test(message)
  );
};

const extractMessageFromValue = (value, depth = 0) => {
  if (value == null || depth > 5) {
    return null;
  }

  if (typeof value === 'string') {
    const trimmed = value.trim();
    return trimmed || null;
  }

  if (typeof value === 'number' || typeof value === 'boolean') {
    return String(value);
  }

  if (Array.isArray(value)) {
    const messages = value
      .map((item) => extractMessageFromValue(item, depth + 1))
      .filter(Boolean);

    return messages.length > 0 ? messages.join(', ') : null;
  }

  if (typeof value === 'object') {
    for (const key of MESSAGE_KEYS) {
      if (Object.prototype.hasOwnProperty.call(value, key)) {
        const extracted = extractMessageFromValue(value[key], depth + 1);
        if (extracted) {
          return extracted;
        }
      }
    }
  }

  return null;
};

/**
 * Extrae un mensaje legible desde errores de Axios o respuestas del API.
 * Siempre devuelve un string seguro para renderizar en la UI.
 */
export const extractApiErrorMessage = (
  error,
  fallback = 'Ha ocurrido un error',
) => {
  const data = error?.response?.data;

  if (data != null) {
    const fromDetail = extractMessageFromValue(data.detail);
    if (fromDetail) {
      return fromDetail;
    }

    const fromMessage = extractMessageFromValue(data.message);
    if (fromMessage) {
      return fromMessage;
    }

    const fromError = extractMessageFromValue(data.error);
    if (fromError) {
      return fromError;
    }

    const fromData = extractMessageFromValue(data);
    if (fromData) {
      return fromData;
    }
  }

  if (error?.code === 'ECONNABORTED') {
    return 'La solicitud tardó demasiado en responder';
  }

  const axiosMessage = error?.message;
  if (axiosMessage && !isTechnicalErrorMessage(axiosMessage)) {
    return axiosMessage;
  }

  return fallback;
};

export default extractApiErrorMessage;
